<template>
  <div
    v-if="
      $route.name != 'mini-sito' &&
      $route.name != 'mini-sitol' &&
      $route.name != 'form-contatti-empty' &&
      $route.name != 'form-contatti-lingua' &&
      $route.name != 'form-contatti-flag' &&
      $route.name != 'form-contatti-emptyl' &&
      $route.name != 'form-contatti-lingual' &&
      $route.name != 'form-contatti-flagl' &&
      $route.name != 'unsub-newsletters' &&
      $route.path != '/login'
    "
  >
    <!-- Footer -->
    <footer
      class="footer text-center text-lg-start bg-light text-muted"
      style="margin-top: 2rem"
    >
      <div class="container">
        <!-- Section: Social media -->
        <section
          class="d-flex justify-content-center justify-content-lg-between p-4 border-bottom"
        >
          <!-- Left -->
          <div class="me-5 d-none d-lg-block">
            <span>Rimani aggiornato tramite i nostri social:</span>
          </div>
          <!-- Left -->

          <!-- Right -->
          <div>
            <a href="mailto:assistenza.cv@nexaco.it" class="me-4 text-reset">
              <i class="fab fa-google"></i>
            </a>
            <a
              href="https://www.instagram.com/cloudvillage.nexaco/"
              class="me-4 text-reset"
            >
              <i class="fab fa-instagram"></i>
            </a>
            <a
              href="https://www.linkedin.com/showcase/cloudvillage/"
              class="me-4 text-reset"
            >
              <i class="fab fa-linkedin"></i>
            </a>
          </div>
          <!-- Right -->
        </section>
        <!-- Section: Social media -->

        <!-- Section: Links  -->
        <section class="">
          <div class="container text-center text-md-start mt-5">
            <!-- Grid row -->
            <div class="row mt-3">
              <!-- Grid column -->
              <div class="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
                <!-- Content -->
                <div
                  class="crediti d-flex flex-column align-items-center align-items-md-start gap-1 mb-4"
                >
                  <span class="crediti-etichetta">powered by</span>
                  <a target="_blank" href="https://www.nexaco.it/">
                    <img
                      src="@/assets/imgs/icons/nexaco.svg"
                      alt="Nexaco"
                      class="crediti-logo"
                    />
                  </a>
                  <span class="crediti-etichetta mt-2">parte di</span>
                  <a target="_blank" href="https://www.centropaghe.it/">
                    <img
                      src="@/assets/imgs/icons/gruppo-centro-paghe.svg"
                      alt="Gruppo Centro Paghe"
                      class="crediti-logo crediti-logo-gruppo"
                    />
                  </a>
                </div>
                <div style="color: #a3a3a3; padding-top: 16px">
                  <p class="versione-git">
                    <span style="font-size: 10px">Frontend:</span>
                    {{ commitFrontend }}
                  </p>
                  <p class="versione-git">
                    <span style="font-size: 10px">Backend:</span>
                    {{ commitBackend }}
                  </p>
                </div>
              </div>
              <!-- Grid column -->

              <!-- Grid column -->
              <div class="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
                <!-- Links -->
                <h6 class="text-uppercase fw-bold mb-4">Link utili</h6>
                <p>
                  <a href="https://www.nexaco.it/" class="text-reset">Nexaco</a>
                </p>
                <p>
                  <a href="https://www.cloudvillage.it/" class="text-reset"
                    >Cloudvillage</a
                  >
                </p>
                <p>
                  <a href="https://www.cloudvillage.it/news/" class="text-reset"
                    >News</a
                  >
                </p>
              </div>
              <!-- Grid column -->

              <!-- Grid column -->
              <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
                <!-- Links -->
                <h6 class="text-uppercase fw-bold mb-4">Contatti</h6>
                <p>
                  <a target="_blank" href="mailto:assistenza.cv@nexaco.it">
                    <i class="fas fa-envelope me-2"></i>
                    assistenza.cv@nexaco.it
                  </a>
                </p>
                <p>
                  <a target="_blank" href="tel:+390418629018">
                    <i class="fas fa-phone me-2"></i>
                    +39 041 862 9018
                  </a>
                </p>
                <p>
                  <a
                    target="_blank"
                    href="https://www.google.com/maps/search/?api=1&query=Via+Monte+Verena+4%2C+30030+Pianiga+VE"
                  >
                    <i
                      class="fas fa-location-pin me-2"
                      style="margin-left: 4px"
                    ></i>
                    Via Monte Verena, 4<br />
                    30030 Pianiga (VE) - Italia
                  </a>
                </p>
                <br />
              </div>
            </div>
            <!-- Grid row -->
          </div>
        </section>
        <!-- Section: Links  -->
      </div>
    </footer>
  </div>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";

export default {
  data() {
    return {
      started: false,
    };
  },
  beforeCreate() {
    this.started = false;
  },
  beforeMount() {
    this.started = true;
  },
  setup() {
    const store = useStore();
    const commitFrontend = ref();
    const commitBackend = ref();
    async function findCommit() {
      commitFrontend.value = process.env.VUE_APP_GIT_HASH;
      commitBackend.value = await store.dispatch("notifications/getGitVersion");
      commitBackend.value = commitBackend.value.version;
    }
    findCommit();
    return {
      commitFrontend,
      commitBackend,
    };
  },
};
</script>

<style scoped src="../../assets/css/components/UI/TheFooter.css"></style>
